import CalendarWithTooltip, {DUMMY_EVENT_ID as D} from '../../../../src/components/Calendar/CalendarWithTooltip'

export const DUMMY_EVENT_ID = D

export default CalendarWithTooltip
